module.exports = __webpack_public_path__ + "static/media/level.9bdd4826.png";